/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'ep-migration-inapp-2055': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-2055/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-3273': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-3273/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-ops-unified-view-revamp': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-ops-unified-view-revamp/placements/in-app/screen-space-flags/render'
			),
	),
};
